import { useStudentDashboardContent } from 'LearnerContentCache';
import { useContentProgress } from 'ContentProgress';
import { memo, useCallback, useEffect, useMemo } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';
import { useAppHeaderViewModel } from 'NavigationHelpers';
import { useCurrentUser } from 'FrontRoyalAngular';
import { hasExternalInstitution } from 'Users';
import { Card } from 'Card';
import { useTranslation } from 'react-i18next';
import { CurriculumV1 } from './studentDashboardNgDirectives';

export const Curriculum = memo(() => {
    const studentDashboardContent = useStudentDashboardContent();
    const contentProgress = useContentProgress();
    const currentUser = useCurrentUser();
    const navigate = useNavigate();
    const AppHeaderViewModel = useAppHeaderViewModel();
    const switchLearningBoxMode = useCallback(() => {
        navigate('/dashboard/currently-studying');
    }, [navigate]);
    const isCurriculumRoute = useMatch('/dashboard/curriculum');
    const { t } = useTranslation('back_royal', { keyPrefix: 'lessons.stream.student_dashboard_learning_box' });

    useEffect(() => {
        if (!isCurriculumRoute) return;
        AppHeaderViewModel.learningBoxMode = { mode: 'playlists' };
        if (hasExternalInstitution(currentUser)) {
            AppHeaderViewModel.setTitleHTML(t('select_playlist_title'));
        } else {
            AppHeaderViewModel.setTitleHTML(t('select_concentration_title'));
        }
    }, [currentUser, t, AppHeaderViewModel, isCurriculumRoute]);

    const CurriculumComponent = useMemo(
        () => (
            <CurriculumV1
                studentDashboardContent={studentDashboardContent}
                contentProgress={contentProgress}
                switchLearningBoxMode={switchLearningBoxMode}
                modifyHeaderSection
            />
        ),
        [studentDashboardContent, contentProgress, switchLearningBoxMode],
    );

    return (
        <div className="flex h-full items-center justify-center p-3.5 sm:p-7.5">
            <div className="hidden w-full sm:block">{CurriculumComponent}</div>
            <div className="block w-full pt-3.5 sm:hidden">
                <Card>{CurriculumComponent}</Card>
            </div>
        </div>
    );
});
